// Meta-Pixel: alle Ereignisse an einer Stelle.
//
// Die Templates liefern nur die Daten - als data-Attribute am Bereich mit
// den Knoepfen. Vorher stand der Code als onclick direkt im Markup, und der
// Kauf wurde an drei Stellen gemeldet (Warenkorb-Template, Kassen-Template
// und rsce_cookieOpen.js), teils ohne Schutz vor doppelter Meldung.
//
//   data-fn-tracking="AddToCart"          Ereignis
//   data-fn-tracking-daten="{...}"         JSON fuer das Ereignis
//   data-fn-tracking-knopf="button_checkout"  nur bei diesem Knopf (optional)
//
// Der Kauf selbst: Klick auf "Kostenpflichtig bestellen" im letzten
// Kassenschritt. Die Summen liefert der Warenkorb der Bestellvorschau ueber
// data-fn-kauf.
//
// fbq gibt es erst, wenn der Besucher im Cookie-Banner Marketing erlaubt
// hat. Ohne Zustimmung passiert hier nichts.

const lesen = (text) => {
    try {
        return JSON.parse(text || '{}');
    } catch (e) {
        return {};
    }
};

const melden = (ereignis, daten) => {
    if (typeof window.fbq !== 'function') {
        return;
    }

    window.fbq('track', ereignis, daten);
};

let kaufGemeldet = false;

document.addEventListener('click', (e) => {
    const knopf = e.target.closest('button, input[type="submit"]');

    if (!knopf) {
        return;
    }

    // Letzter Kassenschritt: Bestellung abschicken
    if (knopf.name === 'nextStep' && knopf.classList.contains('confirm')) {
        const quelle = document.querySelector('[data-fn-kauf]');

        if (!kaufGemeldet && quelle) {
            kaufGemeldet = true;
            melden('Purchase', lesen(quelle.getAttribute('data-fn-kauf')));
        }

        return;
    }

    const bereich = knopf.closest('[data-fn-tracking]');

    if (!bereich) {
        return;
    }

    const nurKnopf = bereich.getAttribute('data-fn-tracking-knopf');

    if (nurKnopf && knopf.name !== nurKnopf) {
        return;
    }

    melden(bereich.getAttribute('data-fn-tracking'), lesen(bereich.getAttribute('data-fn-tracking-daten')));
});
